import { observer } from 'mobx-react-lite';
import logoGreen from './logo_green.svg';
import logoWhite from './logo_segment_white.svg';
import logoDark from './logo_segment_black.svg';
import { appFactory } from '../logic';
import { THEME_IDS } from '../themes/types';

export const Logo = observer(() => {
  const themeId = appFactory.app?.currentTheme?.id;
  const isDarkMode = appFactory.app?.isDarkMode ?? false;

  // DEFAULT theme - always green
  if (themeId === THEME_IDS.DEFAULT_THEME) {
    return <img src={logoGreen} alt="Logo" />;
  }

  // FIRST/PREMIER themes - dark/white based on mode
  const logo = isDarkMode ? logoWhite : logoDark;
  return <img src={logo} alt="Logo" />;
});
